<template>
    <button
        class="l-ss-c-button"
        :class="{ 'l-ss-c-button-loading': loading }"
        :disabled="loading || disabled"
        @click="$emit('click', $event)">
        <transition
            name="scale-down"
            mode="out-in">
            <slot v-if="!loading"></slot>
            <loading-spinner v-else/>
        </transition>
    </button>
</template>

<script>
    import LoadingSpinner from '@/core/components/loading-spinner.vue';

    export default {
        components: { LoadingSpinner },
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>

</style>